/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from './HelpComponent';

class GoogleSearch extends React.Component{
    constructor(){
        super();
        this.sidebarSwitch = this.sidebarSwitch.bind(this);
        this.state = {
            value:"",
            searchResult:[],
            isLoading:false,
            DefaultCustomer:null,
            helpMode : "None"
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.searchResultClick = this.searchResultClick.bind(this);
        this.searchClear = this.searchClear.bind(this);
    }
    componentDidUpdate(){
        let DefaultCustomer = this.state.DefaultCustomer;
        if(DefaultCustomer !== null){
            DefaultCustomer.setAfterTerrainDraw(true);
            DefaultCustomer.setDepthTest(false);
            DefaultCustomer.removeAllEntity();
            const searchResult = this.state.searchResult;
            searchResult.map(
                (Results) =>{
                    var param = {};
                    param.geo = new window.GeoPoint(Results.geometry.location.lng, Results.geometry.location.lat);//幾何
                    param.color = "#ffffff";
                    param.opacity = 1.0;//不透明
                    param.size = 26;//大小
                    param.symbol = Results.icon;
                    param.maxDisplayDistance = 250000;
                    param.absHeight = false; //是否為絕對高度
                    param.label = {color:"#B0C4D0",text:Results.name,font:"微軟正黑體",size:20,borderColor:"000000",borderSize:10}; //加上文字Label
                    var PointEntity = DefaultCustomer.addPointEntity(param);
                    PointEntity.setTooltip(Results.name);
                    PointEntity.setOnClickListener(function(mouse,attr){
                        window.main.OView.goto(param.geo,1000,false);
                    });
                } 
            )
        }
    }
    sidebarSwitch(){
        this.props.setgoogleSearchOpen();
    }
    handleChange(event){
        this.setState({value: event.target.value});
    }
    handleSubmit(event){
        this.setState({isLoading:true});
        const value = this.state.value;
        var URL = "";
        URL+="oview.aspx?https://maps.googleapis.com/maps/api/place/textsearch/json?";
	    URL+="query="+value+"+in+Taiwan&";		    //指定在台灣地區
	    URL+="language=zh-TW&";				        //指定返還的資源使用的語言
        URL+="key=AIzaSyC8Qoy-nO1uLULyvtODx1tqvag9amx7yjs";        
        fetch(URL)
        .then(res => res.json())
        .then(
            (data) => {
                if(data.status==="OK"){
                    let DefaultCustomer = this.state.DefaultCustomer;
                    if(DefaultCustomer !== null){
                        DefaultCustomer.removeAllEntity();
                        window.main.OView.removeLayer(DefaultCustomer);
                    }
                    DefaultCustomer = window.main.OView.addCustomLayer({
                        layername : "_SearchControllerDefaultCustomer"
                    });
                    this.setState({searchResult:data.results,isLoading:false,DefaultCustomer:DefaultCustomer});                    
                }else if(data.status==="ZERO_RESULTS"){
                    window.alertify.error("查無結果");
                    this.setState({isLoading:false});
                }else{
                    window.alertify.error("API回應錯誤");
                    this.setState({isLoading:false});
                }
            }
        )
        event.preventDefault();
    }
    searchResultClick(Results){
        var Point = new window.GeoPoint(Results.geometry.location.lng, Results.geometry.location.lat);
        //var param = {};
        //param.staticAzimuthAngleOffset = 0.25;
        window.main.OView.goto(Point,1000,false);
    }
    searchClear(){
        let DefaultCustomer = this.state.DefaultCustomer;
        if(DefaultCustomer !== null){
            DefaultCustomer.removeAllEntity();
            window.main.OView.removeLayer(DefaultCustomer);
            this.setState({searchResult:[],value:"",DefaultCustomer:null});
        }      
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){   
        const isgoogleSearchOpen = this.props.isgoogleSearchOpen;
        const searchResult = this.state.searchResult;
        const isLoading = this.state.isLoading;
        const sideMenuCSS ={
            overflow : 'inherit',
            transform : isgoogleSearchOpen?'translate3d(0, 0, 0)':'translate3d(-120%, 0, 0)',
            width : '480px'
        };
        const searchCSS = {
            margin: '10px 10px 10px 10px'
        };  
        if(this.state.helpMode === "Search" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/w-QMqXMl70A" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div>
                <div className="ts left vertical sidebar visible menu" id="sideMenu" style={sideMenuCSS}>
                    <div className="ts grid">
                        <div className="row" id="sideMenuTitle">
                            <div className="twelve wide column">
                                <form onSubmit={this.handleSubmit}>
                                    <div class="ts fluid circular icon input" style={searchCSS}>
                                        <input type="text" placeholder="搜尋..." value={this.state.value} onChange={this.handleChange}></input>                                        
                                        <i class="circular search link icon" onClick={this.handleSubmit}></i>
                                    </div>
                                </form>                    
                            </div>
                            <div className="two wide column" id="closeIconColumn" style={{alignSelf:"center",textAlign:"right"}}>
                                <button className="ts circular pulsing  icon button" style={{fontSize:"12px",background:"#ccc"}} onClick={(e)=>this.onHelpClick("Search")}>
                                    <i className="help small icon" ></i>
                                </button>                      
                            </div>
                            <div className="two wide column" id="closeIconColumn">
                                <i className="remove icon" id="closeIcon" onClick={(e)=>this.sidebarSwitch(e)}></i>                        
                            </div>
                        </div>
                    </div>    
                    <a id="searchClearButton" onClick={(e)=>this.searchClear()}>清除搜尋結果</a>  
                    <br></br>
                    {
                        isLoading?
                        <div className="ts item" id="loadingIcon">
                            <i className="spinner loading icon"></i>
                        </div>
                        :
                        <div className="ts vertical buttons item">
                        {
                            searchResult.map(
                                (Results) => 
                                <div className="ts fluid button accordion" id="searchResult" onClick={(e)=>this.searchResultClick(Results)}>
                                    <i className="marker icon"></i>
                                    {Results.name}
                                </div>
                            )   
                        }
                        </div>
                    }
                    <div className="bottom item" id="googleBottom">
                        <a href="https://developers.google.com/maps/documentation?hl=zh-tw" target="_blank">@Google Map API</a>
                    </div>
                    
                </div>
            </div>            
        );
    }
}

export default GoogleSearch;